import SettingsTypes from './settings.types';

export const fetchLicense = () => ({
	type: SettingsTypes.FETCH_LICENSE.PENDING,
});

export const fetchCertificates = () => ({
	type: SettingsTypes.FETCH_CERTIFICATES.PENDING,
});

export const fetchOrders = () => ({
	type: SettingsTypes.FETCH_ORDERS.PENDING,
});

export const checkSpeech = () => ({
	type: SettingsTypes.FETCH_CHECK_SPEECH.PENDING,
});

export const updateLicenseKey = (licensekey) => ({
	type: SettingsTypes.UPDATE_LICENSE.PENDING,
	payload: licensekey,
});

export const toggleMicStatus = () => ({
	type: SettingsTypes.DISABLE_MIC.PENDING,
});

export const checkNotify = () => ({
	type: SettingsTypes.CHECK_NOTIFICATION.PENDING,
});

export const toggleNotification = (notificationState) => ({
	type: SettingsTypes.TOGGLE_NOTIFICATIONS.PENDING,
	payload: notificationState,
});

export const updateSettingsState = (obj) => ({
	type: SettingsTypes.UPDATE_SETTINGS,
	payload: obj,
});

export const handleInputChange = (event) => ({
	type: SettingsTypes.HANDLE_INPUT_CHANGE,
	payload: event,
});

export const sendOtp = () => ({
	type: SettingsTypes.SEND_OTP.PENDING,
});

export const mergeAccount = () => ({
	type: SettingsTypes.MERGE_ACCOUNT.PENDING,
});
